import { AppShell } from "@/components/AppShell";
import { AUSWERTUNGEN_SECTION_SUBTITLES } from "@/lib/auswertungenNav";
import { HoursPipelineReport } from "@/pages/auswertungen/HoursPipelineReport";

export function HoursPipelinePage() {
  return (
    <AppShell
      title="Auswertungen"
      subtitle={AUSWERTUNGEN_SECTION_SUBTITLES["hours-pipeline"]}
    >
      <HoursPipelineReport />
    </AppShell>
  );
}
